import React, { useState } from "react";
import { 
  Button,  
  Stack, 
  Typography, 
  Grid, 
  InputAdornment,
  TextField,
  Alert
} from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { TimePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import { AccessTime } from "@mui/icons-material";

dayjs.extend(duration);

export default function ChooseTimeForm({ task, onSubmit }) {
  const [selectedTime, setSelectedTime] = useState(() => {
    if (task?.quantity) {
      const totalSeconds = parseInt(task.quantity, 10);
      const minutes = Math.floor(totalSeconds / 60);
      const seconds = totalSeconds % 60;
      return dayjs().startOf('day').minute(minutes).second(seconds);
    }
    return dayjs().startOf('day').minute(0).second(0);
  });

  const [error, setError] = useState("");

  const handleSubmit = (event) => {
    event.preventDefault();
    
    if (!selectedTime || (selectedTime.minute() === 0 && selectedTime.second() === 0)) {
      setError("Please select a valid time (minimum 1 second)");
      return;
    }

    const minutes = selectedTime.minute();
    const seconds = selectedTime.second();
    const totalSeconds = (minutes * 60) + seconds;

    // Format display string
    let timeString = "";
    if (minutes > 0) {
      timeString += `${minutes} Minute${minutes !== 1 ? 's' : ''}`;
    }
    if (seconds > 0) {
      if (timeString) timeString += " ";
      timeString += `${seconds} Second${seconds !== 1 ? 's' : ''}`;
    }

    const updatedTask = {
      ...task,
      args: timeString,
      quantity: totalSeconds,
      duration: totalSeconds
    };

    onSubmit(updatedTask);
    setError("");
  };

  return (
    <form onSubmit={handleSubmit}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Stack spacing={3} sx={{ p: 2 }}>
          <Typography variant="h6" gutterBottom>
            Set Cooking Duration
          </Typography>

          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12}>
              <TimePicker
                label="Select Duration"
                value={selectedTime}
                onChange={(newValue) => {
                  setSelectedTime(newValue);
                  setError("");
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    fullWidth
                    error={!!error}
                    helperText={error ? " " : "MM:SS format"}
                    InputProps={{
                      ...params.InputProps,
                      startAdornment: (
                        <InputAdornment position="start">
                          <AccessTime color="action" />
                        </InputAdornment>
                      ),
                    }}
                  />
                )}
                views={['minutes', 'seconds']}
                format="mm:ss"
                minTime={dayjs().startOf('day').second(1)} // Minimum 1 second
                maxTime={dayjs().startOf('day').minute(59).second(59)}
                openTo="minutes"
              />
            </Grid>

            {error && (
              <Grid item xs={12}>
                <Alert severity="error" sx={{ mt: 1 }}>
                  {error}
                </Alert>
              </Grid>
            )}

            <Grid item xs={12}>
              <Button
                fullWidth
                variant="contained"
                color="primary"
                size="large"
                type="submit"
                sx={{ mt: 2 }}
              >
                Confirm Duration
              </Button>
            </Grid>
          </Grid>
        </Stack>
      </LocalizationProvider>
    </form>
  );
}
